import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Modal from 'components/UI/Modal/Modal';
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './PublishModal.module.scss';

export default function PublishModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { rootProject, theme, handlePublication } = useContext(
    ProjectDetailsContext
  );

  const [processIsChecked, setProcessIsChecked] = useState(
    !!rootProject?.is_public
  );
  const [themeIsChecked, setThemeIsChecked] = useState(!!theme?.public);

  function handleClick() {
    handlePublication({ themeIsChecked, processIsChecked });
    setModalIsOpen(false);
  }

  const translate = useTranslate();

  const isStudent = usePermission(['Leerling', 'Leerling Portfolio']);

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="modalContent2">
        <div styleName="image-wrapper">
          <img src="/images/publication-popup-image.svg" alt="publication" />
        </div>
        <h1>
          {translate('project.publication-popups.important-before-publishing')}
        </h1>
        {!isStudent && (
          <p>
            {translate('project.publication-popups.text-01')}
            <br />
            {translate('general.terms.more-info')}{' '}
            <NavLink to="/bibliotheek/groowtorials">
              {translate(
                'project.publication-popups.view-sharecode-groowtorial'
              )}
            </NavLink>
          </p>
        )}
        <p>
          <b>{translate('project.publication-popups.share-theme')}</b>
          <br />
          {translate('project.publication-popups.text-02')}
          <br />
          {translate('project.publication-popups.text-03')}
          <br />
          {translate('project.publication-popups.text-04')}
          <br />
          {translate('project.publication-popups.text-045')}
          <br />
        </p>
        <div styleName="checkbox">
          <Checkbox isChecked={themeIsChecked} setIsChecked={setThemeIsChecked}>
            {translate('project.publication-popups.publish-theme')}
          </Checkbox>
        </div>
        {!!rootProject?.process?.length && (
          <>
            <p>
              <b>{translate('project.publication-popups.share-process')}</b>
              <br />
              {translate('project.publication-popups.text-05')}
              <br />
              {translate('project.publication-popups.text-06')}
              <br />
              {translate('project.publication-popups.text-07')}
              <br />
              {translate('project.publication-popups.confirm')}
              <br />
            </p>
            <div styleName="checkbox">
              <Checkbox
                isChecked={processIsChecked}
                setIsChecked={setProcessIsChecked}
              >
                {translate('project.publication-popups.publish-process')}
              </Checkbox>
            </div>
          </>
        )}
        <div styleName="buttons-wrapper">
          <Button onClick={() => setModalIsOpen(false)} color="grey">
            {translate('general.terms.cancel')}
          </Button>
          <Button onClick={handleClick} inactive={!themeIsChecked}>
            {translate('general.terms.publish')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
